module.exports = __webpack_public_path__ + "img/2021-04-19_10-41-20.84e96017.jpg";